import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMAIL_URL, PESSOAFISICA, SMS_URL, TOKENS } from '../../../app.constants';
import { LoginService } from '../../login/service/login.service';
import { Email } from '../../shared/dominios/email';
import { RecuperarSenha } from '../../shared/dominios/recuperar-senha';
import { Sms } from '../../shared/dominios/sms';
import { EnvioEmail } from '../../shared/interfaces/envioEmail.interface';
import { EnvioSMS } from '../../shared/interfaces/envioSMS.interface';
import { Acesso } from '../../shared/models/acesso.model';
import { PessoaDadosModel } from '../../shared/models/pessoa-dados.model';
import { CrudService } from '../../shared/services/crud-service';
import { FuncoesCriptografia } from '../../shared/util/Funcoes-criptografia';
import { UtilService } from '../../shared/util/util.service';

@Injectable()
export class RecuperarSenhaService extends CrudService<any>  {

  paramEmail: Email;
  paramSms: Sms;

  constructor(
    protected http: HttpClient,
    private loginService: LoginService
  ) {
    super(http, TOKENS);
    this.paramEmail = new Email();
    this.paramSms = new Sms();
  }



  // Requisição HTTP para verifivar se o token existe no back end
  verificarToken(token) {
    return this.http.get(`${TOKENS}/${token}`);
  }

  // newPassword(credenciais) {
  //   return this.http.put(`${TOKENS}/${credenciais.cdCentrus}`, credenciais);
  // }

  cadastrarToken(acesso: Acesso) {
    return this.http.post(`${TOKENS}`, acesso);
  }

  generateTokenUsuario() {
    return FuncoesCriptografia.GenerateKey();
  }


  async getPessoaDadosCPF(cpf: string, token) {
    return this.http
      .get<PessoaDadosModel>(`${PESSOAFISICA}/pessoaDadosCPF/${cpf}`, { headers: new HttpHeaders().set('Authorization', token) })
      .toPromise()

  }


  // Requisição HTTP para enviar o email ao usuário
  async sendAPI(recuperarSenha: RecuperarSenha, tipoContato: number) {

    const token = await this.permitirRequest();
    const pessoa = await this.getPessoaDadosCPF(recuperarSenha.nrCpf, token);


    if (tipoContato === 1) {
      const objEmail = <EnvioEmail>{
        assuntoEmail: 'Recuperação de conta',
        emailDestinatario: recuperarSenha.dsEmail.trim(),
        fromEmail: 'sedes@centrus.org.br',
        textoEmail: `<p>Conta do usuário: </p>  <p> ${pessoa.nome}</p>  Código de acesso: <B><i><p style="color:blue">  ${recuperarSenha.dsTokenAcesso}  </i></B></p>`
        // textoEmail: 'Código de acesso:' + '<B><i><p style="color:blue">' + recuperarSenha.dsTokenAcesso + '</i></B></p>'
      }
      return this.http.post(EMAIL_URL, objEmail, UtilService.getOptionsHeaders())
        .toPromise();
    } else {
      const objSMS = <EnvioSMS>{ numeroTelefone: recuperarSenha.nrFone.toString(), mensagemTexto: 'Codigo de acesso: ' + recuperarSenha.dsTokenAcesso }
      return this.http.post(SMS_URL, objSMS, UtilService.getOptionsHeaders())
        .toPromise();
    }


  }


  // Requisição HTTP para verificar se o email existe no back end.
  saveToken(recuperarSenha: RecuperarSenha, token) {
    return this.http.post(`${TOKENS}`, recuperarSenha, { headers: new HttpHeaders().set('Authorization', token) })
      .toPromise();
  }


  // Requisição HTTP para verifivar se o token existe no back end
  checkToken(codigo, token) {
    return this.http.get(`${TOKENS}/${codigo}`, { headers: new HttpHeaders().set('Authorization', token) })
      .toPromise()
  }


  newPassword(formNewP, user, token) {
    return this.http.put(`${TOKENS}/${user}`, formNewP, { headers: new HttpHeaders().set('Authorization', token) })
      .toPromise();
  }

  async permitirRequest() {
    return await this.loginService
      .loginGetToken();
  }

}





// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/recuperar-senha/service/recuperar-senha.service.ts